import { SxProps } from "@mui/material";

export const dropDownSelectStyle: SxProps = {
  height: "26px",
  fontSize: "12px",
  "&.MuiOutlinedInput-root": {
    "& fieldset": {
      border: "1px solid rgb(211, 211, 211)", // Change the border color here
    },
    "&:hover fieldset": {
      border: "1px solid #af99db", // Change the hover border color here
    },
    "&.Mui-focused fieldset": {
      border: "1px solid #af99db", // Change the focused border color here
    },
    "&.Mui-focused svg": {
      color: "#af99db", // Change the arrow color when focused
    },
  },
};

export const muiOutlinedInputStyle: SxProps = {
  "& .MuiOutlinedInput-root": {
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "1px solid rgba(224,224,224,1)", // Change border color when focused
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: "1px solid rgba(224,224,224,1)", // Change border color on hover
    },
    ".MuiOutlinedInput-notchedOutline": {
      border: "1px solid rgba(224,224,224,1)", // Change default border color
    },
  },
};

export const radioButton: SxProps = {
  "&.Mui-checked": { color: "#af99db" },
  "& .MuiTouchRipple-root": {
    display: "none", // Remove ripple effect
  },
  "&:hover": { backgroundColor: "transparent" },
  "& .MuiSvgIcon-root": { fontSize: 16 },
};